export default __webpack_public_path__ + "static/media/5.c631ca22.png";